<template>
    <div>
        <Appbar/>
        <HeroBanner/>
        <div class="container">
             <div class="row justify-content-center" v-if="success">
                <div class="col-md-8 my-5">
                    <div class="alert alert-success">
                        <p>Thank you for submitting your critique with us.</p>
                        <p>Our team will review and if it meets our standard, it will be approved</p>
                         <router-link to="/debate">Go to debate</router-link>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" v-if="!success">
                <div class="col-8">
                    <h2 >Add Critique (Anti-thesis)</h2>
                    <router-link to="/debates" style="float:right">Back</router-link>
                </div>
                <div class="col-md-8 py-5">         
                <form action="" @submit.prevent="addCritique">
                      <div class="form-group">
                          <label class="required" for="Description">Write Your  Critique</label>
                          <textarea v-model="text" required type="text" class="form-control" rows="15" placeholder="enter your thesis here"> </textarea>
                      </div>
                       <div class="form-group">
                           <label for="basic-url">Upload your picture (Optional)</label>
                            <div class="custom-file">
                            <input accept="image/*" type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadImage" >
                            <label class="custom-file-label" for="validatedCustomFile">
                               {{picTitle ? picTitle :"Choose file..."}}
                            </label>
                             <small class="form-text text-danger">your picture size shouldn't be more than 1MB</small>
                        </div>
                       </div>
                       <div class="form-group">
                           <label for="basic-url">Your PDF (Optional)</label>
                        <div class="custom-file">
                        <input accept="application/pdf"  type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadPdf" >
                        <label class="custom-file-label" for="validatedCustomFile">{{pdfTitle ? pdfTitle :"Choose file..."}}</label>
                        </div>
                         <small  class="form-text text-danger">PDF size shouldn't be more than 1MB</small>
                       </div>
                        <div class="form-group">
                           <label for="basic-url">Your Doc (Optional)</label>
                        <div class="custom-file">
                        <input accept=".doc,.docx"  type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadDoc" >
                        <label class="custom-file-label" for="validatedCustomFile">
                           {{docTitle ? docTitle :"Choose file..."}}
                        </label>
                        <small>{{docTitle}}</small>
                        </div>
                         <small class="form-text text-danger">Document size shouldn't be more than 1MB</small>
                       </div>
                       <label for="basic-url">Your support video (Optional)</label>
                        <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon3">https://www.youtube.com/</span>
                        </div>
                        <input v-model="video" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                        </div>
                        <button class="btn btn-lg btn-danger float-right" type="submit">Submit</button>
                  </form>
                </div>
            </div>
        </div>
     <FinalFooter />
    </div>
</template>

<script>
import Appbar from '../appBar'
import HeroBanner from '../Challenge/Header'
import FinalFooter from '../../components/FinalFooter'
import toasterMixin from '../../mixins/toasterMinxin'

    export default {
        name:'add-anti-thesis',
        components:{
            Appbar,
            HeroBanner,
            FinalFooter
        },
        data() {
            return {
                text:'',
                pic:'',
                pdf:'',
                doc:'',
                video:'',
                docTitle:'',
                picTitle:'',
                pdfTitle:'',
                success:false
            }
        },
        methods: {
            uploadImage(event) {
                this.pic = event.target.files
                this.picTitle = this.pic[0].name   
            },
            uploadDoc() {
                this.doc = event.target.files
                this.docTitle = this.doc[0].name   
            },
            uploadPdf() {
                this.pdf = event.target.files
                this.pdfTitle = this.pdf[0].name   
            },
            addCritique() {
                const formData = new FormData()
                formData.append('debate_article_id', this.$route.params.debateID)
                formData.append('debate_thesis_id', this.$route.params.thesisID)
                formData.append('text',this.text)
                formData.append('video',this.video)

                if(this.pic) {
                    for( let i = 0; i < this.pic.length; i++) {
                    formData.append('pic', this.pic[i])
                    }
                } else {
                    formData.append('pic', '')
                }

               if(this.pdf) {
                    for( let i = 0; i < this.pdf.length; i++) {
                    formData.append('pdf', this.pdf[i])
                    }
               } else {
                   formData.append('pdf', '')
               }

               if(this.doc) {
                    for( let i = 0; i < this.doc.length; i++) {
                    formData.append('doc', this.doc[i])
                    }
               } else {
                   formData.append('doc', '')
               }

                this.$store.dispatch('addAntiThesis', formData)
                    .then(respponse => {
                        // this.toast({
                        //     message:'Critique added success.',
                        //     type:'success'
                        // })
                        this.success = true
                    }).catch(err => {
                        if(err?.respponse?.data == undefined){
                        this.toast({
                            message:'Network error.',
                            type:'error'
                        })
                        }
                    })
            }
        },
         mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#f6f6f6')
        },
        beforeDestroy() {
            document.querySelector('body').removeAttribute('style')
        },
        }
</script>

<style  scoped>
    a{
        border:2px solid #000;
        color:#000;
        padding: 5px 10px;
        text-decoration:none;
    }
    h2{
        display: inline;
    }

 .required:after {
    content:" *";
    color: red;
  }
</style>